function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14 10.293h12.113c4.707 0 8.524 3.816 8.528 8.523v1.793a8.524 8.524 0 01-8.524 8.524H23.473c-1.746 0-2.57 1.352-3.038 2.12-.185.304-.315.517-.423.517-.119 0-.299-.253-.548-.6-.557-.78-1.457-2.037-2.776-2.037H14a8.524 8.524 0 01-8.523-8.524v-1.793A8.524 8.524 0 0114 10.293zM22.129 20a2.129 2.129 0 11-4.258 0 2.129 2.129 0 014.258 0zm-9.625 2.129a2.129 2.129 0 100-4.258 2.129 2.129 0 000 4.258zM29.625 20a2.129 2.129 0 11-4.258 0 2.129 2.129 0 014.258 0z",
  fill: "#fff"
});

var SvgBalloon = function SvgBalloon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBalloon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/balloon.04a2797a.svg";
export { ForwardRef as ReactComponent };